import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://ncuougxicnvxbovnorqd.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5jdW91Z3hpY252eGJvdm5vcnFkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzczNzQxMzcsImV4cCI6MjA1Mjk1MDEzN30.c8Ml7PkpIQr_QtX0_7R-Fh5pJIoT9JWL90a2ZcOIcJA";

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('⚠️ Supabase URL and Anon Key are required!');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);